import { groupBy } from "lodash";
import { memo, useMemo, useRef } from "react";

import { IconButton } from "components/ui-kit/buttons/IconButton";
import { Typography } from "@mui/material";

import { TextInput } from "components/ui-kit/inputs/TextInput";
import SelectItemModal from "./SelectItemModal";

import {
  Container,
  ItemGroup,
  IncludedItems,
  IncludedItem,
  ItemActions,
  ItemFields,
  ButtonContainer,
} from "./styles";

import RemoveIcon from "@mui/icons-material/Close";

import { Add } from "@mui/icons-material";
import ButtonIcon from "components/ui-kit/ButtonIcon";

const IncludedItemsPicker = ({
  data = {},
  updateCategoriesForm = () => { },
  addIncludedItem = () => { },
  deleteIncludedItem = () => { },
}) => {

  const modalRef = useRef();
  const groups = useMemo(() => {
    const withIndex = data.included_items.map((item, index) => ({
      ...item,
      index,
    }));
    return Object.entries(groupBy(withIndex, 'group'))
  }, [data.included_items]);

  return (
    <Container>
      <IncludedItems>
        {groups.map(([groupId, items]) => (
          <ItemGroup key={`group-${groupId}`}>
            <legend>
              Група {groupId}
              <IconButton
                icon={<Add />}
                onClick={() => modalRef.current.open(groupId)}
              />
            </legend>
            {items.map((item) => (
              <IncludedItem key={item.index}>
                
                <ItemActions>
                  <IconButton
                    icon={<RemoveIcon style={{ fontSize: 18 }} />}
                    onClick={deleteIncludedItem.bind(null, item)}
                  />
                </ItemActions>

                <Typography fontFamily="inherit">{item.included_product.title_ua}</Typography>
                <ItemFields>
                  {["included_price", "included_quantity", "trigger_quantity"].map((field, index) => (
                    <TextInput
                      key={field}
                      title={["ціна", "кількість", "на кількість"][index]}
                      type="number"
                      value={item[field]}
                      onChange={(event) => {
                        updateCategoriesForm(
                          `included_items.[${item.index}].${field}`,
                          event.target.value,
                        );
                      }}
                      height="auto"
                      width="85px"
                      stylePadTop="0"
                      styleMarg="0"
                      isStyle
                      isTitle
                    />
                  ))}
                </ItemFields>
              </IncludedItem>
            ))}
          </ItemGroup>
        ))}
      </IncludedItems>

      <ButtonContainer>
        <ButtonIcon
          title='Створити групу і додати товар'
          icon={<Add />}
          positionIcon='left'
          onClick={() => modalRef.current.open()}
        />
      </ButtonContainer>

      <SelectItemModal
        ref={modalRef}
        restaurant={data.restaurant}
        addItem={addIncludedItem}
      />

    </Container>
  );
}

export default memo(IncludedItemsPicker);
